/**
 * App Instance Configuration
 * LEVEL 1: Determines which server/database instance is running (AU vs EU)
 */

import australiaInstance from '../config/instances/australia';
import europeInstance from '../config/instances/europe';
import { DEFAULT_INSTANCE_CONFIG, mergeWithDefaults } from '../config/defaults';

// Available app instances
export const APP_INSTANCES = {
  AU: 'AU',
  EU: 'EU',
};

// Map instance codes to their configurations
// Merge with defaults to ensure all properties exist
const INSTANCE_CONFIGS = {
  [APP_INSTANCES.AU]: mergeWithDefaults(
    DEFAULT_INSTANCE_CONFIG,
    australiaInstance
  ),
  [APP_INSTANCES.EU]: mergeWithDefaults(
    DEFAULT_INSTANCE_CONFIG,
    europeInstance
  ),
};

// Get the current app instance from environment variable
// Defaults to AU if not specified
export const getCurrentInstance = () => {
  return import.meta.env.REACT_APP_INSTANCE || APP_INSTANCES.AU;
};

// Get instance configuration
// Always returns a complete config with all properties defined
export const getInstanceConfig = () => {
  const instance = getCurrentInstance();
  return INSTANCE_CONFIGS[instance] || INSTANCE_CONFIGS[APP_INSTANCES.AU];
};

// Check if running on a specific app instance
export const isInstance = (instanceCode) => {
  return getCurrentInstance() === instanceCode;
};

// Main export for easy access
export const instanceConfig = getInstanceConfig();

export default {
  APP_INSTANCES,
  getCurrentInstance,
  getInstanceConfig,
  instanceConfig,
  isInstance,
};
